import { RunningExperiments, useExperiments } from 'state/experiments';

export enum AMC_VARIANT {
  SINGLE = 'single',
  SINGLE_WITH_CTA = 'single-with-cta',
  CAROUSEL = 'carousel',
  CAROUSEL_WITH_CTA = 'carousel-with-cta',
  DISABLED = 'control',
}

export const useAdaptableMenuCardsVariant = () => {
  const { variant } = useExperiments();

  return Object.keys(AMC_VARIANT).find(amcVariant =>
    variant(RunningExperiments.AdaptableMenuCards, AMC_VARIANT[amcVariant])
  ) as AMC_VARIANT;
};
